module.exports = __webpack_public_path__ + "media/images/athletes/551-d1494a2cb71a517586ba267a5fd45c04.png";